import React from 'react'
import { Button, Modal, notification } from 'antd'
import axiosRequest from '../../../utils/axios/axios-request.util'
import axiosErrorUtil from '../../../utils/axios/axios-error.util'

const UserAgreement = ({ isOpen, user }) => {
  const [loading, setLoading] = React.useState(false)

  const onAgreementAgree = () => {
    setLoading(true)
    axiosRequest(
      'api/v1/users/me',
      'post',
      {
        agreementAccepted: true,
      },
      true,
    )
      .then(() => {
        if (window) {
          notification.success({
            message: 'Success',
            description: 'This page will be reloaded in 3 seconds',
          })
          setTimeout(() => {
            window.location.reload()
          }, 3000)
        }
      })
      .catch((e) => axiosErrorUtil(e))
      .finally(() => setLoading(false))
  }

  if (!user || !user.id) {
    return null
  }

  return (
    <Modal open={isOpen} closable={false} footer={false} centered width={720}>
      <h2 className="mb-3 mb-lg-4">Disclaimer & User Agreement</h2>
      <h5>1. Private System – No Public Offering</h5>
      <p>
        PositiveTrades.com is a private, invitation-only platform. It is not
        advertised publicly, and no services are offered or sold to the general
        public. Access is granted by referral only.
      </p>
      <h5>2. No Financial Advice or Solicitation</h5>
      <p>
        PositiveTrades.com does not provide financial, investment, or trading
        advice of any kind. The system and tools accessible through this website
        are automated, rule-based algorithms that execute trades via
        user-connected brokerage APIs.
      </p>
      <p>
        You acknowledge that by using this platform, you are not receiving
        personalized investment guidance, nor are you entering into an advisory
        relationship. All decisions to use the system are made solely at your
        own risk and discretion.
      </p>
      <p>
        Nothing on this site constitutes a public offer to invest, a
        solicitation to buy or sell securities, or a recommendation of any
        financial instrument. Use of the platform is private, invitation-only,
        and intended exclusively for users who fully understand and accept the
        risks of algorithmic trading.
      </p>
      <h5>3. User-Controlled Brokerage Accounts</h5>
      <p>
        All users operate their own independent brokerage accounts, to which
        they maintain full access and control. PositiveTrades.com does not
        accept, handle, or manage any funds or investments on behalf of users.
      </p>
      <h5>4. API Access & Software Leasing </h5>
      <p>
        Users who choose to connect their brokerage accounts via API acknowledge
        and accept that they are leasing a private, proprietary software system
        for algorithmic trading purposes. This leasing provides limited,
        revocable access to the system for personal use only.
      </p>
      <p>
        PositiveTrades.com does not manage accounts or execute trades directly —
        all activity is performed under the user's own brokerage account and
        control.
      </p>
      <p>
        By connecting your account, you acknowledge that you are responsible for
        enabling, disabling, and overseeing the software’s execution. You
        understand that all trading carries risk, including the potential for
        substantial losses.
      </p>
      <h5>5. No Guarantees or Performance Claims</h5>
      <p>
        Trading involves substantial risk, and you may lose some or all of your
        invested capital. Past performance is not indicative of future results.
        No guarantees are provided regarding outcomes or returns.
      </p>
      <h5>6. Limitation of Liability</h5>
      <p>
        To the fullest extent permitted by law, PositiveTrades.com, its
        operators, and affiliates shall not be held liable for any direct,
        indirect, incidental, or consequential losses arising from your use of
        the website, algorithms, or trading systems.
      </p>
      <h5>7. Not a Registered Financial Entity</h5>
      <p>
        PositiveTrades.com is{' '}
        <strong>
          not a licensed broker, dealer, investment advisor, or financial
          institution
        </strong>
        , and does not purport to act in any such capacity.
      </p>
      <h5 className="mt-3 mt-lg-4">
        By clicking <strong>"I AGREE"</strong>, you confirm that you have read,
        understood, and accepted this Disclaimer & User Agreement and wish to
        proceed voluntarily.
      </h5>
      <div className="mt-4">
        <Button
          type="primary"
          className="w-100"
          loading={loading}
          onClick={() => onAgreementAgree()}
        >
          I Agree
        </Button>
      </div>
    </Modal>
  )
}

export default UserAgreement
